module.exports = __webpack_public_path__ + "static/media/food-4.c872fffa.jpg";